import { use_slice_grid2d } from '@/hooks/store/use_slices';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { useMemo } from 'react';
import { WATCHER_GRID2D__get_collection } from '../watchers/grid2d/WATCHER_GRID2D__get_collection';
import { ROW1D__float } from './ROW1D__float';

interface PROPS {
  entity: DTO__entity_with_grid2d;
}

export function ROW1D__master({ entity }: PROPS) {
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);

  const grid2d = useMemo(() => get_grid2d(), [entity, grids2d_map]);
  /*
   *
   */
  function get_grid2d() {
    let out = DTO__grid2d.CREATE_STUB();

    if (entity.is_stub()) return out;
    if (!grids2d_map.has(entity._id)) return out;

    out = grids2d_map.get_or_assert(entity._id);

    return out;
  }

  function render_row1d() {
    if (entity.is_stub()) return null;
    if (grid2d.is_stub()) return null;

    return <ROW1D__float {...{ grid2d, entity }} />;
  }

  /*
   *
   */
  return (
    <>
      <WATCHER_GRID2D__get_collection entity_id={entity._id} entity_type={entity.type} />

      {render_row1d()}
    </>
  );
}
